import { getCookie } from './cookieHelper';
import { DE_LOCALE } from './i18n';

export const isIwocaDE = () => {
  const host = window.location.host;

  const isDELocale =
    (host && host.includes(`.${DE_LOCALE}`)) ||
    getCookie('locale') === DE_LOCALE;

  return isDELocale;
};
